import Form, { formCreate } from '@/found/components/form';
import request from '@/found/utils/request';
import orders from '../product_info';

formCreate.component('orders', orders);
export default {
  extends: Form,
  components: {
    formCreate: formCreate.$form(),
  },
  data() {
    return {
      // rule: [],
      formFunctionCode: 'youzan_order_detail',
    };
  },
  methods: {

    // 设置规则
    setRule(item) {
      return item;
    },

    // 渲染完成后执行
    formComplete() {
      console.log(this.formConfig.row);
      const ordersRules = this.getRule('orders');
      console.log('orders', ordersRules);
      const orderInfo = JSON.parse(this.formConfig.row.orders);
      ordersRules.props.propsObj = orderInfo;
      this.setValue({
        ...this.formConfig.row,
      });
    },
    // 提交
    submit() {

    },
  },
};
